import createIcon from '../../createIcon';

/**
 * @component @name VerticalAlignTop
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAxMUgxMVYyMUgxM1YxMUgxNkwxMiA3TDggMTFaTTQgM1Y1SDIwVjNINFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VerticalAlignTop = createIcon('VerticalAlignTop', [
  ['path', { d: 'M8 11H11V21H13V11H16L12 7L8 11ZM4 3V5H20V3H4Z', key: 'v69zgp' }],
]);

export default VerticalAlignTop;
